import DiscourseRoute from "discourse/routes/discourse";
export default class Exception extends DiscourseRoute {
  serialize() {
    return "";
  }
}